var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("savedRoutes.createTitle"),
        visible: _vm.innerVisible,
        width: "820px",
        top: "6vh",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
        opened: _vm.onOpened,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "top",
            size: "small",
          },
        },
        [
          !_vm.targetUserId
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("savedRoutes.forUser"),
                    prop: "userId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "reserve-keyword": "",
                        placeholder: _vm.$t(
                          "savedRoutes.userSearchPlaceholder"
                        ),
                        "remote-method": _vm.remoteSearchUsers,
                        loading: _vm.userSearchLoading,
                      },
                      model: {
                        value: _vm.form.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "userId", $$v)
                        },
                        expression: "form.userId",
                      },
                    },
                    _vm._l(_vm.userOptions, function (u) {
                      return _c("el-option", {
                        key: u.userId,
                        attrs: { label: u.label, value: u.userId },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 14 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("savedRoutes.title"),
                        prop: "title",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "title", $$v)
                          },
                          expression: "form.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("savedRoutes.visibility") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.form.visibility,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "visibility", $$v)
                            },
                            expression: "form.visibility",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("savedRoutes.visibilityPrivate"),
                              value: "private",
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("savedRoutes.visibilityPublic"),
                              value: "public",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("savedRoutes.description") } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 2 },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
            ],
            1
          ),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v(_vm._s(_vm.$t("savedRoutes.points"))),
          ]),
          _c(
            "div",
            { staticClass: "pick-row" },
            [
              _c("span", { staticClass: "pick-label" }, [
                _vm._v(_vm._s(_vm.$t("savedRoutes.clickToPlace"))),
              ]),
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.activePoint,
                    callback: function ($$v) {
                      _vm.activePoint = $$v
                    },
                    expression: "activePoint",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "start" } }, [
                    _vm._v(_vm._s(_vm.$t("savedRoutes.start"))),
                  ]),
                  _c("el-radio-button", { attrs: { label: "end" } }, [
                    _vm._v(_vm._s(_vm.$t("savedRoutes.end"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { ref: "mapEl", staticClass: "route-map" }),
          _c(
            "el-row",
            { staticClass: "coord-row", attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "point-title start" }, [
                    _vm._v(_vm._s(_vm.$t("savedRoutes.start"))),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("savedRoutes.address") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.startAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "startAddress", $$v)
                          },
                          expression: "form.startAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("savedRoutes.latitude"),
                                prop: "startLatitude",
                              },
                            },
                            [
                              _c("el-input", {
                                on: { change: _vm.syncMarkers },
                                model: {
                                  value: _vm.form.startLatitude,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "startLatitude", $$v)
                                  },
                                  expression: "form.startLatitude",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("savedRoutes.longitude"),
                                prop: "startLongitude",
                              },
                            },
                            [
                              _c("el-input", {
                                on: { change: _vm.syncMarkers },
                                model: {
                                  value: _vm.form.startLongitude,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "startLongitude", $$v)
                                  },
                                  expression: "form.startLongitude",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "point-title end" }, [
                    _vm._v(_vm._s(_vm.$t("savedRoutes.end"))),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("savedRoutes.address") } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.form.endAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "endAddress", $$v)
                          },
                          expression: "form.endAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 8 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("savedRoutes.latitude"),
                                prop: "endLatitude",
                              },
                            },
                            [
                              _c("el-input", {
                                on: { change: _vm.syncMarkers },
                                model: {
                                  value: _vm.form.endLatitude,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "endLatitude", $$v)
                                  },
                                  expression: "form.endLatitude",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("savedRoutes.longitude"),
                                prop: "endLongitude",
                              },
                            },
                            [
                              _c("el-input", {
                                on: { change: _vm.syncMarkers },
                                model: {
                                  value: _vm.form.endLongitude,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "endLongitude", $$v)
                                  },
                                  expression: "form.endLongitude",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("savedRoutes.cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.saving },
              on: { click: _vm.submit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("savedRoutes.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }